import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgHcaptchaModule } from 'ng-hcaptcha';

import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app.routes';

import { AppComponent } from './app.component';
import { AppErrorHandler } from './app-error-handler';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { NotificationsComponent } from './shared/components/notifications/notifications.component';
import { RgLoaderComponent } from 'src/app/shared/components/loader/loader.component';

import { ApiInterceptor } from './helpers/interceptors/api.interceptor';
import { ApiErrorInterceptor } from './helpers/interceptors/api.error.interceptor';

import { ApplicationInsightsService } from './services/application-insights/application-insights.service';

import { L10nPipe } from 'src/app/helpers/pipes/L10n.pipe';
import { TimePipe } from 'src/app/helpers/pipes/time.pipe';

@NgModule({
  declarations: [AppComponent, FooterComponent, ErrorComponent, NotificationsComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    NgHcaptchaModule.forRoot({
      siteKey: environment.hCaptchaSiteKey
    }),
    NgbModule,
    RgLoaderComponent,
    L10nPipe,
    TimePipe,
    HeaderComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    CookieService,
    ApplicationInsightsService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
